export enum UnitSystem {
  METRIC = 'metric',
  IMPERIAL = 'imperial',
}
